import i18n from '@/libs/i18n'
import useEntityCrud from '@/composable/useEntityCrud'
import useEntityHelper from '@/composable/useEntityHelper'
import useErrorManager from '@/composable/useErrorManager'

export default function useArticlesList() {
  const MODULE_NAME = 'manager-categories'
  const ENDPOINT = 'manager-categories'
  const errorManager = useErrorManager()
  const { getAlt } = useEntityHelper()
  function convertResource(resource, selectedLang) {
    return {
      ...resource,
      title: resource.title[selectedLang],
      keywords: resource.keywords[selectedLang],
      description: resource.description[selectedLang],
      lang: selectedLang,
      managerCatImage: resource.managerCatImageFileId,
      managerCatImageAlt: getAlt('managerCatImageFileId', resource, selectedLang),
      managerCatLink: { name: 'pages-manager-categories-edit', params: { id: resource._id, lang: selectedLang } },
    }
  }

  const entity = useEntityCrud(MODULE_NAME, ENDPOINT, convertResource)

  // Table Handlers
  const tableColumns = [
    {
      key: 'title', label: i18n.t('general.title'), type: 'textImage', textKey: 'title', imageKey: 'managerCatImage', linkKey: 'managerCatLink',
    },
    { key: 'description', label: i18n.t('general.description'), type: 'truncate-text' },
    {
      key: 'createdAt', label: i18n.t('general.createdAt'), type: 'dateTime', sortable: true,
    },
    {
      key: 'updatedAt', label: i18n.t('general.updatedAt'), type: 'dateTime', sortable: true,
    },
    { key: 'actions', label: i18n.t('general.actions'), sortable: false },
  ]

  return {
    ...entity,
    errorManager,
    convertResource,
    tableColumns,
  }
}
